import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Row, CardImg, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { dAPI_Delete_Ingetration, putAPI_Update_OnOff } from '../../../../../constants/APIs';
import BookingEngineUrlIntegration from './BookingEngineUrlIntegration';
import BookingEngineLogo from '../../../../../assets/be_url_icon.svg';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

export default function BookingEngineUrlIntegrationThumb({
    integration,
    allProperties,
    LoadIntegrations
}) {
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [formatedProperties, setFormatedProperties] = useState('');
    const [moreProperties, setMoreProperties] = useState('');
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
        !integration.disabled
    );
    useEffect(() => {
        const result = integration.channelDetails.map(item => {
            return allProperties.find(elem => elem.id === item.propertyId);
        });
        if (result.length > 2) {
            const filterResults = result.slice(0, 2);
            setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));
            setMoreProperties('and ' + (result.length - filterResults.length) + ' more')
        }
        else {
            const filterResults = result.filter(elem => elem !== undefined);
            setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));

        }
    }, [integration, allProperties]);

    const handleOnOff = (onoff) => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
            data: { disabled: onoff },
        }).then((res) => {
            console.log('on/off');
        });
    };
    const handleSwitchChange = (value) => {
        //console.log(value)
        setCheckedPrimarySmall(value);
        handleOnOff(!value);
    };
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        }).then(res => {
            setTimeout(() => {
                LoadIntegrations();
            }, 300)
        });
    };
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This action will permanently remove the integration. Are you sure you want to delete the integration?
                                </ModalHeader>
                                <ModalBody className="d-flex justify-content-space-between">
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Confirm
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            {integration ?
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                    <Card className="d-flex flex-row" style={{ height: '215px' }}>

                        <h3 className="integrationChannel">
                            <img
                                src={BookingEngineLogo}
                                alt="Logo"
                            /></h3>
                        <Switch
                            className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                            checked={checkedPrimarySmall}
                            onChange={(primary) => handleSwitchChange(primary)}
                        />
                        <CardBody>
                            <Row>
                                <Colxx xxs="12" className="mb-3 mt-5">
                                    <NavLink
                                        to={{
                                            pathname:
                                                '/app/pages/booking-engine-url/' + integration.id,
                                        }}
                                        key={integration.id}
                                    >
                                        <div className="text-center">
                                            <div className="mb-1">
                                                {integration.name}
                                            </div>
                                            <div className="mb-1">
                                                {/* {integration.channelDetails.bookingUrl.length < 50 ?
                                            integration.channelDetails.bookingUrl :
                                            integration.channelDetails.bookingUrl.substring(0, 50) + "..."
                                        } */}
                                            </div>
                                            <div className="mb-2">
                                                <b>{formatedProperties} </b>
                                                <b>{moreProperties}</b>
                                            </div>
                                        </div>
                                    </NavLink>

                                </Colxx>
                            </Row>
                        </CardBody>
                        <div className='integrationdelete'>
                            <FontAwesomeIcon
                                icon={faTrashAlt}
                                style={{ color: 'var(--theme-color-1)' }}
                                cursor="pointer"
                                onClick={toggle}
                            />
                        </div>
                    </Card>
                </Colxx> : null}
            {generateDeleteButton()}
        </Fragment>
    );
}